import { useEffect, useState } from "react";
import { Lock } from "lucide-react";

function useCountdown(expiresAt) {
  const [remaining, setRemaining] = useState(0);
  useEffect(() => {
    if (!expiresAt) return;
    const tick = () => setRemaining(Math.max(0, new Date(expiresAt).getTime() - Date.now()));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [expiresAt]);
  return remaining;
}

export function formatMs(ms) {
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return `${h}h ${String(m).padStart(2, "0")}m ${String(sec).padStart(2, "0")}s`;
}

export function LockBadge({ lock, schoolName, mine, floating = true }) {
  const remaining = useCountdown(lock?.expires_at);
  if (!lock) return null;
  const purchased = lock.status === "purchased";
  return (
    <div
      data-testid="dress-lock-countdown"
      className={`glass-dark text-ivory px-4 py-2.5 flex items-center gap-2.5 shadow-[0_0_30px_rgba(183,110,121,0.35)] ${
        floating ? "absolute top-4 left-4 z-20 rounded-sm" : "rounded-sm"
      }`}
    >
      <Lock className="w-3.5 h-3.5 text-champagne" strokeWidth={1.5} />
      <div className="leading-tight">
        <div className="font-label text-[10px] text-champagne/90">
          {purchased ? "Permanently Secured" : mine ? "You've locked this" : `Locked · ${schoolName || "School"}`}
        </div>
        <div className="font-body text-sm tabular-nums">
          {purchased ? "Yours forever" : remaining > 0 ? formatMs(remaining) : "Lock expired"}
        </div>
      </div>
    </div>
  );
}
